<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:13:36
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
    <div style="padding: 20px 0px 0px 20px;">
  
        <el-form style="display: flex;flex-wrap: wrap;">

              
              <el-form-item label="所在地域:"  style="display: flex;width: 33%;" >
                  <el-select v-model="input1" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
                      <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                  </el-select>
              </el-form-item>
              

              <el-form-item label="学生姓名:" style="display: flex;width: 33%; margin-left: -14px;" >
                    <el-select  placeholder="请选择学生姓名"  v-model="input2"  style="width: 100%" clearable  filterable>
                        <el-option  v-for="item in getStudentsArr_s" :key=" item.id + 'student_s' "  :value="item.id"  :label="item.realname"   >  </el-option>
                    </el-select>
              </el-form-item>

              <el-form-item label="教师姓名:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择教师" v-model="input3" style="width: 100%" clearable filterable>
                      <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="科目:" style="display: flex;width: 33%;margin-left: 28px;">
                <el-select placeholder="请选择" v-model="input4" style="width:100%;" clearable filterable>
                    <el-option v-for="item in subjectArr" :key="item.id" :value="item.id" :label="item.categoryName"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="学生类型" style="display: flex;width: 33%; margin-left: -38px;" >
                <el-select v-model="input5" style="width:100%;" placeholder="请选择学生类型" filterable clearable>
                     <el-option v-for="item in classTypsArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="签到情况" style="display: flex;width: 33%;" >
                <el-select v-model="input6" style="width:100%;" placeholder="请选择签到情况" filterable clearable>
                     <el-option v-for="item in classTypsArr1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="上课方式" style="display: flex;width: 33%;" >
                <el-select v-model="input7" style="width:100%;" placeholder="请选择上课方式" filterable clearable>
                     <el-option v-for="item in classTypsArr11" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="首节课" style="display: flex;width: 33%;" >
                <el-select v-model="input10" style="width:100%;" placeholder="请选择首节课" filterable clearable>
                     <el-option v-for="item in classTypsArr111" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="上课日期:" style="display: flex;width: 60%;margin-left: -14px;">
                  <el-date-picker  style="width: 100%;"  v-model="dateTime" type="daterange"  value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"   clearable  > </el-date-picker>
              </el-form-item>

  
              <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>
  
        </el-form>
  
  
          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="600">
              <el-table-column prop="courseDate" label="上课日期" width="140" show-overflow-tooltip></el-table-column>
              <el-table-column prop="regionName" label="所在地域" show-overflow-tooltip></el-table-column>
              <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>
              <el-table-column prop="teacherName" label="教师姓名" show-overflow-tooltip></el-table-column>

              <el-table-column prop="classType" label="学生类型" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.classType === 1">规划</span>
                  <span v-if="scope.row.classType === 2">线下</span>
                  <span v-if="scope.row.classType === 3">纯补课</span>
                </template>
              </el-table-column>

              <el-table-column prop="categoryName" label="科目" show-overflow-tooltip></el-table-column>
              <el-table-column prop="classDate" label="上课时间" width="140"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="educationType" label="上课方式" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.educationType === 1">网课</span>
                  <span v-if="scope.row.educationType === 2">上门</span>
                  <span v-if="scope.row.educationType === 3">门店</span>
                </template>
              </el-table-column>

              <el-table-column prop="isFirstClass" label="首节课" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.isFirstClass == 1 || scope.row.isFirstClass == '1'">是</span>
                  <span v-if="scope.row.isFirstClass == 0 || scope.row.isFirstClass == '0'">否</span>
                </template>
              </el-table-column>

              <el-table-column prop="isSignName" label="签到情况" show-overflow-tooltip></el-table-column>

              <el-table-column width="150" prop="signMinute" label="上课时长（分钟）" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="color: red;">{{ scope.row.signMinute }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="signSchoolTime" label="上课签到时间" width="180" show-overflow-tooltip></el-table-column>
              <el-table-column prop="schoolTimeRemark" label="上课签到异常原因" width="280" show-overflow-tooltip></el-table-column>
              <el-table-column prop="signFinishClass" label="下课签到时间" width="180" show-overflow-tooltip></el-table-column>
              <el-table-column prop="finishClassRemark" label="下课签到异常原因" width="280" show-overflow-tooltip></el-table-column>
              <el-table-column prop="supplementaryTime" label="补签时间" width="180" show-overflow-tooltip></el-table-column>
              <el-table-column prop="supplementaryRemark" label="补签原因" width="280" show-overflow-tooltip></el-table-column>


              <el-table-column  width="400"  v-if="userRealname === '赵薇' || userRealname === '苏芮'"  label="学生地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.latitude && (scope.row.precisionLng && scope.row.address)" @click="handleView(1,scope.row)"> 
                    <div style="color: #16b8f9;" v-if="scope.row.latitude">纬度： {{ scope.row.latitude }} </div>
                    <div style="color: #16b8f9;" v-if="scope.row.precisionLng">经度： {{ scope.row.precisionLng }} </div>
                    <div style="color: #e30cef;" v-if="scope.row.address">位置： {{ scope.row.address }} </div>
                  </div>
                </template>
              </el-table-column>


              <el-table-column  width="400"  v-if="userRealname === '赵薇' || userRealname === '苏芮'" prop="userLat" label="记录上课触发位置" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.userLat && (scope.row.userLat.userLatinfo && scope.row.userLat.userLnginfo)"  @click="handleView(2,scope.row)">
                    <div style="color: #16b8f9;" v-if="scope.row.userLat.userLatinfo">纬度： {{ scope.row.userLat.userLatinfo }} </div>
                    <div style="color: #16b8f9;" v-if="scope.row.userLat.userLnginfo">经度： {{ scope.row.userLat.userLnginfo }} </div>
                    <div style="color: #e30cef;" v-if="scope.row.userLat.addressName">位置： {{ scope.row.userLat.addressName }} </div>
                    <div style="color: #e30cef;" v-if="scope.row.userLat.time">时间： {{ scope.row.userLat.time }} </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column  width="400" v-if="userRealname === '赵薇' || userRealname === '苏芮'" prop="checkInLat" label="记录下课触发位置" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.checkInLat && (scope.row.checkInLat.userLatinfo && scope.row.checkInLat.userLnginfo)"  @click="handleView(3,scope.row)">
                    <div style="color: #16b8f9;" v-if="scope.row.checkInLat.userLatinfo">纬度：{{ scope.row.checkInLat.userLatinfo }} </div>
                    <div style="color: #16b8f9;" v-if="scope.row.checkInLat.userLnginfo">经度：{{ scope.row.checkInLat.userLnginfo }} </div>
                    <div style="color: #e30cef;" v-if="scope.row.checkInLat.addressName">地址：{{ scope.row.checkInLat.addressName }} </div>
                    <div style="color: #e30cef;" v-if="scope.row.checkInLat.time">时间：{{ scope.row.checkInLat.time }} </div>
                  </div>
                </template>
              </el-table-column>
              

          </el-table>
  
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>



          <el-dialog title="上下课签到位置信息比对" :visible.sync="dialogVisible" width="95%" center :before-close="handleViewClier">
            <div style="display: flex;justify-content: space-between;overflow: hidden; margin-top: 40px;">
              <div style="width: 33%; height: 720px; border: 4px solid #1a9ce3;">
                <div style="text-align: center;  margin-bottom: 17px; font-size: 18px;  font-weight: 900;position: absolute; top: 67px; ">学生地址</div>
                <div id="container1" style="width: 100%; height: 700px; "></div>
                <div v-if="showTitle1" style="margin-left: 9%; position: absolute;  top: 46%;">{{ showTitle1 }}</div>
              </div>
              <div style="margin: 0px 10px;"></div>
              <div style="width: 33%; height: 720px; border: 4px solid #dfbf14;">
                <div style="text-align: center;  margin-bottom: 17px; font-size: 18px;  font-weight: 900;position: absolute; top: 67px; ">上课签到按钮时间: {{ startTime }} </div>
                <div id="container2" style="width: 100%; height: 700px; "></div>
                <div v-if="showTitle2" style="margin-left: 9%; position: absolute;  top: 46%;">{{ showTitle2 }}</div>
              </div>
              <div style="margin: 0px 10px;"></div>
              <div style="width: 33%; height: 720px; border: 4px solid #d66f0f;">
                <div style="text-align: center;  margin-bottom: 17px; font-size: 18px;  font-weight: 900;position: absolute; top: 67px; ">下课签到按钮时间 {{ endTime }} </div>
                <div id="container3" style="width: 100%; height: 700px; "></div>
                <div v-if="showTitle3" style="margin-left: 9%; position: absolute;  top: 46%;">{{ showTitle3 }}</div>
              </div>
            </div>
          </el-dialog>
  
  
    </div>
  </template>
  
  <!-- 使用这个新的引入方式 -->
  <script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD"></script>
  <script charset="utf-8" src="https://mapapi.qq.com/web/mapComponents/geoutils/1/modules/tools/tools.min.js"></script>
  
  <script>
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { handleStudent, handleTeacher } from "../utils/publicInterface";
  import { getStudentsType } from "@/api/fiveClassApi"
  import { getTeachers } from "@/api/fiveClassApi"
  import { ApiGetStudentList, } from "@/api/apiTask";
  import { getSubject } from "@/api/fiveClassApi"

  export default {
    components:{
  
    },
    data() {
        return{

            startTime: '',
            endTime: '',

            dialogVisible: false,

            userRealname:'',
            isShowName: '',
  
            dateTime:[],
  
            options:[],
            options1:[{id:1,realname:'初级老师'},{id:2,realname:'中级老师'},{id:3,realname:'高级老师'},{id:4,realname:'特级老师'}],
            options2:[{id:1,realname:'待审批'},{id:2,realname:'审批中'},{id:3,realname:'驳回'},{id:4,realname:'已完成'}],
  
            input1:'',
            input2:'',
            input3:'',
            dataList:[],

            input10:'',
  
            pageNum: 1,
            pageSize: 10,
            total: 0,
            input7:'',
  
            form:{
                input1:'',
                input2:true,
                input3:'',
            },
  
            titleDialogShowvisible:false,
            titleDialogShowvisible1:false,
            textareainput:'',
  
            fromlabel:'',
            placeholderfrom:'',
            titleDialogShowvisibletitle1:'',
            
            optionsListt:[],
            getStudentsArr_s:[],
            subjectArr:[],

            input4:'',
            input5:'',
            input6:'',

            classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
            classTypsArr1:[
              { label: '异常', value: 1 },
              { label: '正常', value: 2 },
              { label: '已补签', value: 3 },
            ],

            classTypsArr11:[
              { label: '网课', value: 1 },
              { label: '上门', value: 2 },
              { label: '门店', value: 3 },
            ],

            classTypsArr111:[
              { label: '是', value: '1' },
              { label: '否', value: '0' },
            ],


          Map1:null,
          Map2:null,
          Map3:null,
          markerLayer1:null,
          markerLayer2:null,
          markerLayer3:null,

          showTitle1:'',
          showTitle2:'',
          showTitle3:'',

          circleLayer1:null,

          objShowView: { },

        }
    },
  
    mounted(){
      getTeachers().then(res => {  this.options = res.data })
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.optionsListt = res.data.data})
      ApiGetStudentList().then((res) => {  let { data } = res; this.getStudentsArr_s = data;  });
      getSubject().then(res => {   this.subjectArr = res.data   })
      this.getApiList()
    },
  
  
    methods:{


        handleView(type,row){
          console.log(row, '查看位置 ====>>>>>>>>>>>> ')
          this.dialogVisible = true
          this.objShowView = row

          let { userLat, checkInLat, latitude, precisionLng} = row

          let lat1 = latitude
          let lng1 = precisionLng

          let lat2 = userLat.userLatinfo
          let lng2 = userLat.userLnginfo 

          let lat3 = checkInLat.userLatinfo
          let lng3 = checkInLat.userLnginfo 


          this.startTime = userLat.time ? userLat.time : '2020-01-01 00:00:00'
          this.endTime = checkInLat.time ? checkInLat.time : ''


          this.$nextTick(() => {

             if(lat1 && lng1){
                this.showTitle1 = ''
                this.Map1 = new TMap.Map(document.getElementById('container1'), {
                    center: new TMap.LatLng(lat1, lng1),
                    zoom: 17,
                    pitch: 0,
                    rotation: 0,
                    draggable: true,
                    showControl: true,
                });

                this.markerLayer1 = new TMap.MultiMarker({
                  map: this.Map1,
                  styles: {
                      'marker': new TMap.MarkerStyle({
                          width: 25,
                          height: 35,
                          anchor: { x: 12, y: 35 },
                          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-red.png'
                      })
                  },
                  geometries: [{
                      id: 'marker1',
                      styleId: 'marker',
                      position: new TMap.LatLng(lat1, lng1),
                      properties: {
                          title: '当前位置'
                      }
                  }]
                });

                 // 创建圆形区域
                this.circleLayer1 = new TMap.MultiPolygon({
                    map: this.Map1,
                    styles: {
                        'circle': new TMap.PolygonStyle({
                            color: 'rgba(0, 200, 0, 0.3)', 
                            showBorder: true,
                            borderColor: 'rgba(0, 30, 100, 0.8)',
                            borderWidth: 2
                        })
                    },
                    geometries: [{
                        id: 'circle1',
                        styleId: 'circle',
                        paths: this.getCirclePath(new TMap.LatLng(lat1, lng1), 200) // 100米半径的圆
                    }]
                });


             }else{
              this.showTitle1 = '当前暂无学生经纬度信息 不存在~'
             }

            if(lat2 && lng2){
                this.showTitle2 = ''
                this.Map2 = new TMap.Map(document.getElementById('container2'), {
                    center: new TMap.LatLng(lat2, lng2),
                    zoom: 17,
                    pitch: 0,
                    rotation: 0,
                    draggable: true,
                    showControl: true,
                });

                this.markerLayer2 = new TMap.MultiMarker({
                  map: this.Map2,
                  styles: {
                      'marker': new TMap.MarkerStyle({
                          width: 25,
                          height: 35,
                          anchor: { x: 12, y: 35 },
                          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
                      }),
                      'current': new TMap.MarkerStyle({
                           width: 25,
                           height: 35,
                           anchor: { x: 12, y: 35 },
                           src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-red.png'
                      })
                  },
                  geometries: [
                      {
                        id: 'marker1',
                        styleId: 'marker',
                        position: new TMap.LatLng(lat2, lng2),
                        properties: {
                            title: '当前位置'
                        },
                      },
                      {
                         id: 'current_marker',
                         styleId: 'current',
                         position: new TMap.LatLng(lat1, lng1),
                         properties: {
                             title: '当前位置'
                         }
                      }
                  ]
              });

              this.circleLayer2 = new TMap.MultiPolygon({
                    map: this.Map2,
                    styles: {
                        'circle': new TMap.PolygonStyle({
                            color: 'rgba(0, 200, 0, 0.3)', 
                            showBorder: true,
                            borderColor: 'rgba(0, 30, 100, 0.8)',
                            borderWidth: 2
                        }),
                        'circle1': new TMap.PolygonStyle({
                            color: 'rgba(311, 010, 111, 0.3)', 
                            showBorder: true,
                            borderColor: 'rgba(0, 30, 100, 0.8)',
                            borderWidth: 2
                        }),
                    },
                    geometries: [
                      {
                        id: 'circle1',
                        styleId: 'circle',
                        paths: this.getCirclePath(new TMap.LatLng(lat1, lng1), 200) // 100米半径的圆
                      },
                      {
                        id: 'circle1',
                        styleId: 'circle1',
                        paths: this.getCirclePath(new TMap.LatLng(lat2, lng2), 10) // 100米半径的圆
                      },
                  ]
              });
            }else{
              this.showTitle2 = '当前暂无老师上课经纬度信息 不存在~'
            }

            if(lat3 && lng3){
              this.showTitle3 = ''
              this.Map3 = new TMap.Map(document.getElementById('container3'), {
                  center: new TMap.LatLng(lat3, lng3),
                  zoom: 17,
                  pitch: 0,
                  rotation: 0,
                  draggable: true,
                  showControl: true,
              });

              this.markerLayer3 = new TMap.MultiMarker({
                  map: this.Map3,
                  styles: {
                      'marker': new TMap.MarkerStyle({
                          width: 25,
                          height: 35,
                          anchor: { x: 12, y: 35 },
                          src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
                      }),
                      'current': new TMap.MarkerStyle({
                           width: 25,
                           height: 35,
                           anchor: { x: 12, y: 35 },
                           src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-red.png'
                      })
                  },
                  geometries: [
                    {
                      id: 'marker1',
                      styleId: 'marker',
                      position: new TMap.LatLng(lat3, lng3),
                      properties: {
                          title: '当前位置'
                      }
                    },
                    {
                       id: 'current_marker',
                       styleId: 'current',
                       position: new TMap.LatLng(lat1, lng1),
                       properties: {
                           title: '当前位置'
                       }
                    }
                ]
              });
              this.circleLayer3 = new TMap.MultiPolygon({
                    map: this.Map3,
                    styles: {
                        'circle': new TMap.PolygonStyle({
                            color: 'rgba(0, 200, 0, 0.3)', 
                            showBorder: true,
                            borderColor: 'rgba(0, 30, 100, 0.8)',
                            borderWidth: 2
                        }),
                        'circle1': new TMap.PolygonStyle({
                            color: 'rgba(311, 010, 111, 0.3)', 
                            showBorder: true,
                            borderColor: 'rgba(0, 30, 100, 0.8)',
                            borderWidth: 2
                        }),
                    },
                    geometries: [
                      {
                        id: 'circle1',
                        styleId: 'circle',
                        paths: this.getCirclePath(new TMap.LatLng(lat1, lng1), 200) // 100米半径的圆
                      },
                      {
                        id: 'circle1',
                        styleId: 'circle1',
                        paths: this.getCirclePath(new TMap.LatLng(lat3, lng3), 10) // 100米半径的圆
                      },
                  ]
              });
            }else{
              this.showTitle3 = '当前暂无老师下课经纬度信息 不存在~'
            }

          });

        },


         handleViewClier(){
            this.objShowView = {} 

            if (this.infoWindow) {
                this.infoWindow.close();
                this.infoWindow = null;
            }
            if (this.markerLayer1) {
                this.markerLayer1.setMap(null);
                this.markerLayer1 = null;
                this.circleLayer1.setMap(null);
                this.circleLayer1 = null;
            }
            if (this.Map1) {
                this.Map1.destroy();
                this.Map1 = null;
            }
            const containers = document.getElementById('container1');
            if (containers) {
                containers.innerHTML = '';
            }
            

            if (this.markerLayer2) {
                this.markerLayer2.setMap(null);
                this.markerLayer2 = null;
                this.circleLayer2.setMap(null);
                this.circleLayer2 = null;
            }
            if (this.Map2) {
                this.Map2.destroy();
                this.Map2 = null;
            }
            const container = document.getElementById('container2');
            if (container) {
                container.innerHTML = '';
            }


            if (this.markerLayer3) {
                this.markerLayer3.setMap(null);
                this.markerLayer3 = null;
                this.circleLayer3.setMap(null);
                this.circleLayer3 = null;
            }
            if (this.Map3) {
                this.Map3.destroy();
                this.Map3 = null;
            }
            const containerss = document.getElementById('container3');
            if (containerss) {
                containerss.innerHTML = '';
            }



            this.dialogVisible = false;
        },

        getCirclePath(center, radius) {
           const points = [];
            const pointsNum = 64; // 圆形由多少个点组成
            const EARTH_RADIUS = 6378137; // 地球半径（米）
            
            for (let i = 0; i < pointsNum; i++) {
                const rad = (i * 2 * Math.PI) / pointsNum;
                const dx = radius * Math.cos(rad);
                const dy = radius * Math.sin(rad);
                
                // 将经纬度偏移转换为实际经纬度
                const dlng = (dx / (EARTH_RADIUS * Math.cos(center.getLat() * Math.PI / 180))) * 180 / Math.PI;
                const dlat = (dy / EARTH_RADIUS) * 180 / Math.PI;
                
                points.push(new TMap.LatLng(
                    center.getLat() + dlat,
                    center.getLng() + dlng
                ));
            }
            return [points];
        },
  
        getApiList(){

            const userInfo = JSON.parse(localStorage.getItem('admin'))
            const isShowName = localStorage.getItem('isShowName')
            console.log(userInfo)

            this.isShowName = isShowName
            this.userRealname = userInfo.realname

            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                courseDateStart: this.dateTime.length ? this.dateTime[0] : '' ,
                courseDateEnd : this.dateTime.length ? this.dateTime[1] : '' ,
                regionName: this.input1,
                studentId: this.input2,
                teacherId: this.input3,
                categoryId: this.input4,
                classType: this.input5,
                isSign: this.input6,
                educationType: this.input7,
                isFirstClass: this.input10,
            }
            axios.post(`${apiBaseUrl}/scheduleSign/findPage`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
  
                  if(res.data.code === 200){
  
                    let data = res.data.data
                    this.dataList = data.records ? data.records.map((itms)=>{
                        itms.checkInLat = itms.checkInLat ? JSON.parse(itms.checkInLat) : ''
                        itms.userLat = itms.userLat ? JSON.parse(itms.userLat) : ''
                        return itms
                    }) : []

                    console.log(this.dataList, '列表List ====>>>>>>>>>>>> ')

                    this.pageNum = data.current ? data.current : 0
                    this.pageSize = data.size ? data.size : 10
                    this.total = data.total ? data.total : 0
  
                    this.$message({ message: res.data.message , type: "success" })
                  }
            }).catch((err)=>{
                this.dataList= []
                this.pageSize = 10
                this.pageNum = 1
                this.total = 0
                this.$message({ message: err , type: "error" })
            })
        },
  
  
        titlerejectDialogShowClr(){
          this.titleDialogShowvisible = false
        },
  
        titlerejectDialogShowClr1(){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        },
  
        titlerejectDialogShowSubt1(){
          if(this.textareainput){
            this.textareainput = ''
            this.titleDialogShowvisible1 = false
          }else{
            this.$message({ message: '请填写备注~' , type: "warning" })
          }
        },
  
        searchBtns(){
            this.pageNum = 1
            this.pageSize = 10
            this.getApiList()
        },

        exportBtns(){
            let data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                courseDateStart: this.dateTime.length ? this.dateTime[0] : '' ,
                courseDateEnd : this.dateTime.length ? this.dateTime[1] : '' ,
                regionName: this.input1,
                studentId: this.input2,
                teacherId: this.input3,
                categoryId: this.input4,
                classType: this.input5,
                isSign: this.input6,
                educationType: this.input7,
                isFirstClass: this.input10,
            }
            axios.post(`${apiBaseUrl}/scheduleSign/excelScheduleSign`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "上课签到.xlsx"; 
                    downloadLink.click();
                    this.$message({ message: res.data.message , type: "success" })
                }
                else{
                    this.$message({ message: res.data.message , type: "error" })
                }
            })
        },
  
        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input10  = ''
            this.input7 = ''
            this.input6 = ''
            this.dateTime = []
            this.pageNum = 1
            this.pageSize = 10
            this.getApiList()
        },
  
        handleSizeChange(e){
            this.pageSize = e
            this.getApiList()
        },
  
        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },
  
        handleClickView(type,itme){
          console.log(itme)
          if(type === 2){
            this.titleDialogShowvisible = true
          }
          if(type === 1){
            this.titleDialogShowvisible = true
          }
  
        },
  
        titlerejectDialogShowClrB(){
          this.titleDialogShowvisibletitle1 = '审批意见'
          this.fromlabel = '备注：'
          this.placeholderfrom = '请输入意见'
          this.titleDialogShowvisible1 = true
        },
        titlerejectDialogShowClrS(){
          this.titleDialogShowvisibletitle1 = '驳回原因'
          this.fromlabel = '驳回原因：'
          this.placeholderfrom = '请输入驳回原因'
          this.titleDialogShowvisible1 = true
        },
    }
  
  }
  </script>
  
  
  <style scoped lang="less">
  
    .no-click {
        pointer-events: none;
    }
  
    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }
  
  
  </style>
  


// WEBPACK FOOTER //
// src/SignInForClass/SignInForClass.vue